import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from "../../nest-api";
import { ResponseTypeDto, ResponseSaveDto, ResponseHistoryDto } from '../dto/skill.dto';

@Injectable()
export class SkillSf6Api {

  private readonly service: string = '';
  private readonly model: string = 'sf6s';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public type(lang: string): Observable<ResponseTypeDto> {
    console.log('type', lang)
    const method: string = 'GET';
    const func: string = 'skill/type';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof lang !== 'undefined' && lang !== null) urlParams.lang = lang;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseTypeDto>(method, url, func, params, body);
  }

  public save(payload: any): Observable<ResponseSaveDto> {
    console.log('API | save', payload)    
    const method: string = 'POST';
    const func: string = 'skill/save';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveDto>(method, url, params, urlParams, body);
  }

  public listing(empId: string, lang: string): Observable<ResponseHistoryDto> {
    console.log('API | listing', empId, lang)        
    const method: string = 'GET';
    const func: string = 'skill/listing';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof lang !== 'undefined' && lang !== null) urlParams.lang = lang;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseHistoryDto>(method, url, func, params, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/skill.api.ts